import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { GlobalFormGroup } from '@app/services/formulario';
import { convertErrorsNz } from '@app/utiles/ng-zorro';

@Component({ standalone: false, selector: 'app-form-reactive-color-picker',
  templateUrl: './reactive-color-picker.component.html',
})
export class FormReactiveColorPicker {
  @Input() label: string = '';
  @Input() required = false;
  @Input() inputFormControl: GlobalFormGroup<string> = null;
  readonly convertErrorsNz = convertErrorsNz;
  // Necesario para evitar el error de tipado para [formControl] (https://github.com/ngx-formly/ngx-formly/issues/2842)
  readonly asFormControl = (formControl: AbstractControl): FormControl => formControl as FormControl;
  onChange(value: string) {
    this.inputFormControl.setValue(value);
    this.inputFormControl.markAsDirty();
  }
}
